/**
 * API Client Module
 * Exports API client instance and related utilities
 */

import { createApiClient } from './client';
import { getApiConfig } from './config';

// Create API client instance
export const api = createApiClient(getApiConfig());

// Export types
export type { ApiRequestConfig, ApiResponse, ApiErrorDetails, ApiClientOptions } from './types';

// Export error classes
export {
  ApiError,
  ValidationError,
  AuthenticationError,
  AuthorizationError,
  NotFoundError,
  RateLimitError,
  NetworkError,
} from './types';

// Export type guards
export {
  isApiError,
  isValidationError,
  isAuthenticationError,
  isAuthorizationError,
  isNotFoundError,
  isRateLimitError,
  isNetworkError,
} from './types';

// Export HttpMethod enum
export { HttpMethod } from './types';

// Export API client class
export { ApiClient, createApiClient } from './client';

// Export interceptors
export {
  authenticationInterceptor,
  requestIdInterceptor,
  customHeadersInterceptor,
  responseNormalizationInterceptor,
  errorStatusInterceptor,
  tokenRefreshInterceptor,
  rateLimitInterceptor,
  errorNotificationInterceptor,
  createCustomHeaderInterceptor,
  createLoggingInterceptor,
} from './interceptors';

// Export endpoints
export {
  endpoints,
  authEndpoints,
  userEndpoints,
  storeEndpoints,
  offeringEndpoints,

  orderEndpoints,
  paymentEndpoints,
  subscriptionEndpoints,
  couponEndpoints,
  analyticsEndpoints,
  reviewEndpoints,
  uploadEndpoints,
  healthEndpoints,
  disputeEndpoints,
  reportEndpoints,
  adminEndpoints,
  getEndpointUrl,
} from './endpoints';

// Export configuration
export {
  getApiBaseUrl,
  getApiTimeout,
  getApiConfig,
  API_BASE_URL,
  API_TIMEOUT,
  RETRY_CONFIG,
  RATE_LIMIT_CONFIG,
  CACHE_CONFIG,
  AUTH_CONFIG,
} from './config';
